
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"-18031.375 6816.25 16.148 16.147"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 7163","transform":"translate(-18030.625 6817)","fill":"none","stroke":"#35bd26","stroke-width":"1.5"}},[_c('circle',{attrs:{"cx":"7.324","cy":"7.324","r":"7.324","data-name":"Ellipse 903"}}),_c('path',{attrs:{"d":"M4.106 7.499l2.517 2.335 4.4-4.833","stroke-linecap":"round","stroke-linejoin":"round","stroke-miterlimit":"10"}})])])
          )
        }
      }
    